import qs from 'query-string';

import { CLIENT_ID, OAUTH_URL } from '../../utils/env';

const params = {
  business_partner_id: '810d1d00-4312-43e5-bd31-d8373fdd24c7', // Zalando's own business partner ID
  realm: 'users',
  response_type: 'token',
  client_id: CLIENT_ID,
};

export default `${OAUTH_URL}/oauth2/authorize?${qs.stringify(params)}`;
